import { render } from "./DiagnosisFieldBlock.vue?vue&type=template&id=eebd0d9a&scoped=true"
import script from "./DiagnosisFieldBlock.vue?vue&type=script&lang=js"
export * from "./DiagnosisFieldBlock.vue?vue&type=script&lang=js"

import "./DiagnosisFieldBlock.vue?vue&type=style&index=0&id=eebd0d9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eebd0d9a"]])

export default __exports__